import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import "./Navbar.scss";

function Navbar() {

    const [activeTab, setActiveTab] = useState('home');
    const [certTab, setCertTab] = useState('Certifications');

    useEffect(() => {
        setActiveTab(window.location.href.split('/')[3]);
        window.addEventListener('resize', (e) => {
            if (window.innerWidth < 510) {
                setCertTab('Cert');
            }else {
                setCertTab('Certifications')
            }
        });

    }, [activeTab])

    return (
        <div className="Navbar">
            <div></div>
            <div className="navbar-container">
                {
                    (activeTab === 'home' || activeTab === '') ? (
                        <div className="home-active">
                            <Link>Home</Link>
                        </div>
                    ) : (
                        <div onClick={() => {
                                setActiveTab('home')
                            }}  className="home">
                            <Link to="/">Home</Link>
                        </div>
                    )
                }
                
                {
                    (activeTab === 'projects') ? (
                        <div className="home-active">
                            <Link>Projects</Link>
                        </div>
                    ) : (
                        <div onClick={() => {
                            setActiveTab('projects')
                        }}  className="project">
                            <Link  to="/projects">Projects</Link>
                        </div>
                    )
                }

            {
                    (activeTab === 'certifications') ? (
                        <div className="home-active">
                            <Link>{certTab}</Link>
                        </div>
                    ) : (
                        <div onClick={() => {
                                setActiveTab('certifications')
                            }}  className="certs">
                            <Link to="/certifications">{certTab}</Link>
                        </div>
                    )
                }

                 {
                    (activeTab === 'about') ? (
                        <div className="home-active">
                            <Link>About</Link>
                        </div>
                    ) : (
                        <div onClick={() => {
                            setActiveTab('about')
                        }} className="abouts">
                            <Link to="/about">About</Link>
                        </div>
                    )
                }
            
            </div>
        </div>
    )
}

export default Navbar
